'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-1887e1af.js');
var React = require('react');
var styled = require('styled-components');
var notistack = require('notistack');
var components_Subtitle2_index = require('../Subtitle2/index.js');
var components_SvgIcon_index = require('../SvgIcon/index.js');
var components_ButtonText_index = require('../ButtonText/index.js');
var minusCircle = require('../../minus-circle-ca219aaf.js');
var constants_properties = require('../../constants/properties.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Container = styled__default["default"].div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: ", ";\n  padding: 15px 9px;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  max-width: 438px;\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n  padding: 15px 9px;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  max-width: 438px;\n"])), function (_a) {
    var dark = _a.theme.colors.background.dark;
    return dark;
}, function (_a) {
    var shadows = _a.theme.shadows;
    return shadows[8];
});
var Message = styled__default["default"](components_Subtitle2_index["default"])(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  padding: 0 15px;\n"], ["\n  color: ", ";\n  padding: 0 15px;\n"])), function (_a) {
    var light = _a.theme.colors.text.light;
    return light;
});
var StartIcon = styled__default["default"](components_SvgIcon_index["default"]).attrs({
    size: constants_properties.SVG_ICON_SIZES.MEDIUM,
})(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  margin-left: 9px;\n"], ["\n  margin-left: 9px;\n"])));
var ActionButton = styled__default["default"].button(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin-right: 6px;\n  height: 100%;\n"], ["\n  background: none;\n  border: none;\n  cursor: pointer;\n  margin-right: 6px;\n  height: 100%;\n"])));
var ActionButtonText = styled__default["default"](components_ButtonText_index["default"])(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  white-space: nowrap;\n"], ["\n  color: ", ";\n  white-space: nowrap;\n"])), function (_a) {
    var light = _a.theme.colors.text.light;
    return light;
});
var renderStartIcon = function (variant) {
    switch (variant) {
        case constants_properties.SNACKBAR_VARIANTS.SUCCESS:
            return React__default["default"].createElement(StartIcon, { icon: minusCircle.SvgCheck, stroke: constants_properties.SVG_ICON_COLORS.LIGHT });
        case constants_properties.SNACKBAR_VARIANTS.ERROR:
            return (React__default["default"].createElement(StartIcon, { icon: minusCircle.SvgExclamationMark, fill: constants_properties.SVG_ICON_COLORS.LIGHT }));
        case constants_properties.SNACKBAR_VARIANTS.WARNING:
            return React__default["default"].createElement(StartIcon, { icon: minusCircle.SvgMinusCircle, stroke: constants_properties.SVG_ICON_COLORS.LIGHT });
        case constants_properties.SNACKBAR_VARIANTS.DOWNLOAD:
            return React__default["default"].createElement(StartIcon, { icon: minusCircle.SvgDownload, stroke: constants_properties.SVG_ICON_COLORS.LIGHT });
        case constants_properties.SNACKBAR_VARIANTS.PLAIN:
        default:
            return null;
    }
};
var Snackbar = React__default["default"].forwardRef(function (_a, ref) {
    var id = _a.id, text = _a.text, variant = _a.variant, action_text = _a.action_text, onActionClick = _a.onActionClick;
    var closeSnackbar = notistack.useSnackbar().closeSnackbar;
    var onClick = function () {
        onActionClick && onActionClick();
        closeSnackbar(id);
    };
    return (React__default["default"].createElement(Container, { ref: ref, role: "alert" },
        renderStartIcon(variant),
        React__default["default"].createElement(Message, null, text),
        action_text && onActionClick && (React__default["default"].createElement(ActionButton, { onClick: onClick },
            React__default["default"].createElement(ActionButtonText, null, action_text)))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports["default"] = Snackbar;
